module.exports = __webpack_public_path__ + "img/27.06734d6f.jpg";